import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SafePipeModule } from 'safe-pipe';
import { PDFViewerComponent } from './pdf-viewer.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SafePipeModule,
    PdfViewerModule,
  ],
  declarations: [PDFViewerComponent]
})
export class PDFViewerComponentModule {}

